export enum UserRolesEnum {
    USER = "user",
    STAFF = "agencyStaff"
};